import { FileText, Video, Calculator, Calendar } from "lucide-react";

const EstimateProcess = () => {
  const steps = [
    {
      icon: FileText,
      title: "Submit Request",
      description: "Fill out our detailed form with your property and cleaning requirements. The more information you provide, the more accurate your estimate will be."
    },
    {
      icon: Video,
      title: "Consultation",
      description: "Choose your preferred contact method. We recommend video calls for the most accurate estimates, especially for commercial properties and first-time customers."
    },
    {
      icon: Calculator,
      title: "Custom Quote",
      description: "Our experienced team analyzes your requirements and property details to create a personalized estimate tailored to your specific needs."
    },
    {
      icon: Calendar,
      title: "Schedule Service",
      description: "Once you approve the estimate, we'll work with your schedule to book your cleaning service at a convenient time that works for you."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            How Our <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">Estimate Process</span> Works
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We've streamlined our process to provide you with fast, accurate estimates and exceptional service from start to finish.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent text-accent-foreground rounded-full flex items-center justify-center text-sm font-bold">
                    {index + 1}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-border transform -translate-x-8" />
                  )}
                </div>
                <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium">
            <Calendar className="w-4 h-4" />
            Most estimates provided same day!
          </div>
        </div>
      </div>
    </section>
  );
};

export default EstimateProcess;